"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var ConfirmationReserveOnline_1 = require("./ConfirmationReserveOnline");
var ConfirmationReserveOnlineScreen = function () {
    return <ConfirmationReserveOnline_1.default />;
};
exports.default = ConfirmationReserveOnlineScreen;
